module.exports = __webpack_public_path__ + "img/dash-card-packages.8d919f7a.svg";